"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSystemColor = exports.rgba = void 0;
const colors_1 = require("./colors");
const rgba = (hex, opacity) => {
    let clearedHex = hex;
    if (hex[0] === '#') {
        clearedHex = hex.substr(1);
    }
    const r = parseInt(clearedHex.substr(0, 2), 16);
    const g = parseInt(clearedHex.substr(2, 2), 16);
    const b = parseInt(clearedHex.substr(4, 2), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
exports.rgba = rgba;
const getSystemColor = (type) => {
    switch (type) {
        case 'error':
            return colors_1.colors.system.error;
        case 'success':
            return colors_1.colors.system.success;
        default:
            return colors_1.colors.system.info;
    }
};
exports.getSystemColor = getSystemColor;
